module.exports = __webpack_public_path__ + "media/images/how-img-1152-55f49461baa1d305d84496af3ce083b4.svg";